import { render } from "./SalesQuotesNewOperPage.vue?vue&type=template&id=4a82e265&ts=true"
import script from "./SalesQuotesNewOperPage.vue?vue&type=script&lang=ts"
export * from "./SalesQuotesNewOperPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__